/**
 * TOPローディングと下層ページ遷移アニメーション（localStorage版・テキスト色補正あり）
 -----------------------------------*/
async function initLoading() {
  const body = document.body;
  const overlay = document.getElementById('loading-overlay');
  const isTop = body.classList.contains('template-index');
  const fvVideo = document.getElementById('fv-video');
  
  // localStorageを使用して、永続的に訪問済みか判定
  const hasVisited = localStorage.getItem('hasVisitedTop');

  // 状態の初期化
  body.removeAttribute('data-leaving');
  body.classList.remove('is-main-active', 'is-transitioning');
  
  if (overlay) {
    overlay.classList.remove('is-active', 'is-loaded');
    // TOPかつ未訪問の場合のみオーバーレイを表示
    overlay.style.display = (isTop && !hasVisited) ? 'flex' : 'none';
  }

  /**
   * 動画の準備を待機する共通Promise
   */
  const waitForVideo = () => new Promise((resolve) => {
    if (!fvVideo) return resolve();
    if (fvVideo.readyState >= 3) return resolve();
    fvVideo.addEventListener('canplaythrough', () => resolve(), { once: true });
    setTimeout(resolve, 2000); 
  });

  /**
   * 動画再生を実行する共通関数
   */
  const playFvVideo = () => {
    if (fvVideo) {
      fvVideo.querySelectorAll('source').forEach(s => {
        const ds = s.getAttribute('data-src');
        if (ds && !s.getAttribute('src')) s.setAttribute('src', ds);
      });
      const vds = fvVideo.getAttribute('data-src');
      if (vds && !fvVideo.getAttribute('src')) fvVideo.setAttribute('src', vds);

      fvVideo.load();
      fvVideo.dataset.loaded = '1';
      fvVideo.currentTime = 0;

      const playPromise = fvVideo.play();
      if (playPromise !== undefined) {
        playPromise.catch(error => console.warn("Playback prevented", error));
      }

    }
  };

  if (isTop) {
    if (!hasVisited) {
      /* --- 初回アクセス時：フル演出を実行 --- */
      
      // ① グレー文字パラパラ開始
      setTimeout(() => {
        body.classList.add('is-main-active');
      }, 200);

      // ② 白文字ワイプ開始
      setTimeout(() => {
        if(overlay) overlay.classList.add('is-active');
      }, 1500); 

      const animationMinTime = new Promise(resolve => setTimeout(resolve, 2800));
      await Promise.all([waitForVideo(), animationMinTime]);

      // ④ 幕上げ開始 ＋ 動画再生開始
      if(overlay) {
        playFvVideo();
        overlay.classList.add('is-loaded');
        setTimeout(() => {
          window.dispatchEvent(new CustomEvent('loading-complete'));
          overlay.style.display = 'none';
        }, 700);
      }
      
      // 訪問済みフラグをセット（次回からスキップ）
      localStorage.setItem('hasVisitedTop', 'true');

    } else {
      /* --- 2回目以降：演出をスキップして即時準備完了 --- */
      
      // アニメーション後の最終状態にするためのクラス付与
      body.classList.add('is-main-active'); 

      // 指定されたテキスト要素を白くする
      const loadingTexts = document.querySelectorAll('.loading-text-base');
      loadingTexts.forEach(el => {
        el.style.color = '#fff';
      });
      
      // 動画の準備だけ待って即再生
      // await waitForVideo();
      playFvVideo();
      await waitForVideo();

      // 他のスクロール演出などを発火させるための通知
      window.dispatchEvent(new CustomEvent('loading-complete'));
      
      if(overlay) {
        overlay.style.display = 'none';
      }
    }
    
    sessionStorage.removeItem('isTransition');

  } else {
    /* --- 下層ページの処理（既存のまま） --- */
    const isTransition = sessionStorage.getItem('isTransition');
    if (isTransition) {
      const transitionDelay = new Promise(resolve => setTimeout(resolve, 400));
      await Promise.all([waitForVideo(), transitionDelay]);

      playFvVideo();
      
      setTimeout(() => {
        body.classList.remove('is-transitioning');
        body.classList.remove('loading');        // ← 追加
        sessionStorage.removeItem('isTransition');
        window.dispatchEvent(new CustomEvent('loading-complete'));
      }, 0);
    } else {
      body.classList.remove('is-transitioning');  // ← 追加
      body.classList.remove('loading');            // ← 追加
      window.dispatchEvent(new CustomEvent('loading-complete'));
    }
  }
}

// 初回ロード時
window.addEventListener('load', initLoading);

// Safari ブラウザバック対応
window.addEventListener('pageshow', (event) => {
  if (event.persisted) {
    window.location.reload(); 
  }
});


/**
 * ページ遷移演出：沈み込み開始
 -----------------------------------*/
document.addEventListener('click', (e) => {
  const link = e.target.closest('a');
  if (!link) return;

  const href = link.getAttribute('href');
  
  if (
    href && 
    (href.startsWith('/') || href.startsWith(window.location.origin)) && 
    !href.includes('#') && 
    link.target !== '_blank' &&
    !e.metaKey && !e.ctrlKey
  ) {
    if (link.classList.contains('js-modal-close') || link.closest('.video-modal')) return;

    e.preventDefault();
    sessionStorage.setItem('isTransition', 'true');
    
    document.body.classList.add('is-transitioning');
    
    document.body.setAttribute('data-leaving', 'true');
    
    setTimeout(() => {
      window.location.href = href;
    }, 400); 
  }
});

// 下層ページのみ、loading-complete後に要素を浮上させる
window.addEventListener('loading-complete', () => {
  if (document.body.classList.contains('template-index')) return;
  const revealItems = document.querySelectorAll('.reveal-item, .js-scroll-trigger');
  revealItems.forEach((el, i) => {
    setTimeout(() => el.classList.add('is-visible'), i * 150);
  });
});


/**
 * ブラウザバック（Bfcache）対策
 -----------------------------------*/
window.addEventListener('pageshow', (event) => {
  if (event.persisted) {
    // Bfcacheから復元された（ブラウザバックで戻った）場合
    const body = document.body;

    // 1. 遷移中・離脱中のクラス・属性をすべて削除
    body.classList.remove('is-transitioning');
    body.classList.remove('is-main-active');
    body.removeAttribute('data-leaving');
    
    // 2. オーバーレイを即座に非表示にする
    const fadeOverlay = document.getElementById('js-fade-overlay');
    if (fadeOverlay) {
      fadeOverlay.style.opacity = '0';
      fadeOverlay.style.display = 'none';
    }

    const loadingOverlay = document.getElementById('loading-overlay');
    if (loadingOverlay) {
      // TOPページの場合は初期状態に戻すか、あるいは非表示にする
      // ここでは再アクセス扱いとして非表示にする例
      loadingOverlay.style.display = 'none';
    }

    // 3. 沈み込んでいたコンテンツを元に戻す
    // CSSのtransitionが効かないよう、一旦クラスを操作して強制的に戻す
    const targetElements = document.querySelectorAll('#MainContent, .header-wrapper, .footer, .cv-area');
    targetElements.forEach(el => {
      el.style.opacity = '1';
      el.style.transform = 'translateY(0)';
    });

    // 4. セッションストレージのクリーンアップ
    sessionStorage.removeItem('isTransition');
  }
});


/**
 * TOPアクセス時は必ずページ丈夫戻るように
 -----------------------------------*/
window.addEventListener('load', () => {
  // TOPページかどうかを判定（サイトのドメイン直下、またはindex.htmlの場合）
  const isTopPage = window.location.pathname === '/' || window.location.pathname.endsWith('index.html');

  if (isTopPage) {
    // ブラウザのスクロール復元を無効化
    if ('scrollRestoration' in history) {
      history.scrollRestoration = 'manual';
    }
    // 最上部へ移動
    window.scrollTo(0, 0);
  } else {
    // 下層ページでは標準の挙動（スクロール位置復元）を許可
    if ('scrollRestoration' in history) {
      history.scrollRestoration = 'auto';
    }
  }
});


